import {
  convertFromRaw,
  convertToRaw,
  EditorState,
  SelectionState,
} from "draft-js"
import { ReactNode } from "react"
import { convertRawFromOriginalBlocks } from "../../../../../../../../../libs/converter/block-converter/from-original-block"
import { convertToOBlocksFromRawState } from "../../../../../../../../../libs/converter/block-converter/from-raw-draft-content-state"
import { Types } from "../../../../../../../../../rpcs/dist/EpisodeRPC"
import { EDIT_TYPE } from "../../../../../../../types"
import BaseEditor, { IBaseEditorProps } from "./base-editor"

interface IState {
  editorState: EditorState
}

// DraftJsを使ったエディターの基底クラス
export default abstract class BaseDraftEditor extends BaseEditor<
  IBaseEditorProps,
  IState
> {
  constructor(props: IBaseEditorProps) {
    super(props)
    this.state = {
      editorState: EditorState.createWithContent(
        convertFromRaw(convertRawFromOriginalBlocks(props.content.blocks)),
      ),
    }
    this.onChange = this.onChange.bind(this)
    this.setFocus = this.setFocus.bind(this)
    this.save = this.save.bind(this)
    this.cancel = this.cancel.bind(this)
    this.getCurrentOBlocks = this.getCurrentOBlocks.bind(this)
    this.shouldRemoveContent = this.shouldRemoveContent.bind(this)
    this.editMode = this.editMode.bind(this)
  }

  public componentDidMount(): void {
    if (this.props.content._editMetaData.type === EDIT_TYPE.EDIT) {
      this.setFocus()
    }
  }

  public abstract render(): ReactNode

  protected editMode() {
    this.props.actions.clickContentEditor(this.props.content.uuid)
  }

  protected onChange(editorState: EditorState) {
    if (this.props.content._editMetaData.type !== EDIT_TYPE.EDIT) {
      this.editMode()
    }
    this.setState({ editorState })
  }

  protected save() {
    if (this.shouldRemoveContent()) {
      return this.props.actions.saveWithRemoveContent(this.props.content.uuid)
    }

    if (this.shouldShallowRemove()) {
      return this.props.actions.saveWithShallowRemoveContent(
        this.props.content.uuid,
      )
    }

    this.props.actions.saveContent({
      ...this.props.content,
      blocks: this.getCurrentOBlocks(),
    })
  }

  protected cancel() {
    if (this.shouldRemoveContent()) {
      return this.props.actions.cancelWithRemoveContent(this.props.content.uuid)
    }
    this.props.actions.cancelContent(this.props.content.uuid)
  }

  protected shouldShallowRemove() {
    return (
      this.isEmptyText(this.getCurrentOBlocks()) &&
      !this.isEmptyText(this.props.content.blocks)
    )
  }

  protected shouldRemoveContent() {
    if (this.props.content.type === Types.Introduction) {
      return false
    }
    return (
      this.isEmptyText(this.getCurrentOBlocks()) &&
      this.isEmptyText(this.props.content.blocks)
    )
  }

  protected setFocus() {
    const content = this.state.editorState.getCurrentContent()
    const blockMap = content.getBlockMap()

    const key = blockMap.last().getKey()
    const length = blockMap.last().getLength()

    const selection = new SelectionState({
      anchorKey: key,
      anchorOffset: length,
      focusKey: key,
      focusOffset: length,
    })
    this.onChange(EditorState.forceSelection(this.state.editorState, selection))
  }

  private getCurrentOBlocks() {
    return convertToOBlocksFromRawState(
      convertToRaw(this.state.editorState.getCurrentContent()),
    )
  }
}
